<svg version="1.1" viewBox="0 0 83.85 84.84"
    xmlns="http://www.w3.org/2000/svg">
    <defs>
        <style>.cls-1{fill:#ffffff;}.cls-2{fill:#ffffff;}</style>
    </defs>
    <title>Allen Institute for Cell Science</title>
    <g transform="translate(1.0784e-5 -.0001205)" data-name="Layer 1">
        <path class="cls-2"
            d="m27.87 17.74a42.64 42.64 0 0 0 0-15.28 41.64 41.64 0 0 0-13.08 7.64 41.85 41.85 0 0 0 13.08 7.64" />
        <path class="cls-2"
            d="m22.91 31.31a43 43 0 0 0 4.41-11.06 44.56 44.56 0 0 1-14.41-8.43 42.52 42.52 0 0 0-11.7 20.46 44.8 44.8 0 0 1 14.4 8.41 42 42 0 0 0 7.3-9.38" />
        <path class="cls-2"
            d="m56 17.74a41.87 41.87 0 0 0 13.07-7.64 41.75 41.75 0 0 0-13.07-7.63 42.81 42.81 0 0 0 0 15.27" />
        <path class="cls-2"
            d="m0.69 50a42.11 42.11 0 0 0 13-7.62 42.11 42.11 0 0 0-13-7.62 42.42 42.42 0 0 0 0 15.24" />
        <path class="cls-2"
            d="m56 67.1a43 43 0 0 0 0 15.27 41.87 41.87 0 0 0 13-7.63 41.87 41.87 0 0 0-13-7.64" />
        <path class="cls-2"
            d="m82.64 52.55a44.57 44.57 0 0 1-14.39-8.41 42.23 42.23 0 0 0-7.31 9.38 42.75 42.75 0 0 0-4.39 11.07 44.62 44.62 0 0 1 14.45 8.41 42.53 42.53 0 0 0 11.64-20.45" />
        <path class="cls-2"
            d="m12.91 73a44.41 44.41 0 0 1 14.4-8.43 42.58 42.58 0 0 0-4.4-11.06 42.31 42.31 0 0 0-7.3-9.39 44.64 44.64 0 0 1-14.4 8.42 42.56 42.56 0 0 0 11.7 20.46" />
        <path class="cls-2"
            d="m68.25 40.69a44.75 44.75 0 0 1 14.39-8.41 42.52 42.52 0 0 0-11.7-20.46 44.27 44.27 0 0 1-14.39 8.42 42.75 42.75 0 0 0 4.39 11.07 41.78 41.78 0 0 0 7.31 9.38" />
        <path class="cls-2"
            d="m83.16 34.8a42.23 42.23 0 0 0-13 7.62 42.43 42.43 0 0 0 13 7.62 42.42 42.42 0 0 0 0-15.24" />
        <path class="cls-2"
            d="m30.25 66.32a45.35 45.35 0 0 1 0 16.83 41.24 41.24 0 0 0 23.37 0 45.56 45.56 0 0 1 0-16.83 41.17 41.17 0 0 0-23.35 0" />
        <path class="cls-2"
            d="m27.83 82.37a43 43 0 0 0 0-15.27 41.71 41.71 0 0 0-13 7.64 41.71 41.71 0 0 0 13 7.63" />
        <path class="cls-2"
            d="m53.6 18.52a45.83 45.83 0 0 1 0-16.84 41.41 41.41 0 0 0-23.35 0 45 45 0 0 1 0 16.85 41.6 41.6 0 0 0 11.68 1.67 41.31 41.31 0 0 0 11.67-1.68" />
        <path class="cls-1"
            d="m58.76 32.58a45.36 45.36 0 0 1-4.62-11.58 44 44 0 0 1-12.21 1.74 43.55 43.55 0 0 1-12.2-1.74 45.35 45.35 0 0 1-4.64 11.57 44.93 44.93 0 0 1-7.63 9.84 44.34 44.34 0 0 1 7.63 9.83 45.06 45.06 0 0 1 4.62 11.58 43.75 43.75 0 0 1 24.43 0 45.79 45.79 0 0 1 4.62-11.58 44.64 44.64 0 0 1 7.63-9.83 44.93 44.93 0 0 1-7.63-9.84" />
    </g>
</svg>